// src/components/.../Footer.jsx
import React, { useState } from "react";
import logo from "../../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import { sendContactMessage } from "src/redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

import facebookIcon from "../../../images/facebook.png";
import instagramIcon from "../../../images/instagram.png";

function Footer() {
  const { t } = useTranslation();
  const today = new Date();
  const dispatch = useDispatch();
  const { contactLoading } = useSelector((state) => state.auth || state.client || {});
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !message) return;
    dispatch(sendContactMessage({ email, message }));
    setEmail("");
    setMessage("");
  };

  return (
    <footer className="footer footercx" style={{ padding: "10px 0", zIndex: 999 }}>
      <section>
        <div className="container mt-3">
          <div className="mt-3 row gy-2 gy-md-3 justify-content-between">

            {/* ── Contact Us ── */}
<div className="col-12 col-md-4 col-lg-3 col-xl-3" style={{ marginBottom: '24px' }}>
              <div className="widget">
                <h4 className="widget-title text-white mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {t("Contact Us")}
                </h4>

                <p className="mb-2 d-flex align-items-center gap-2">
                  <FaPhone style={{ color: "#1fc17d", transform: "scaleX(-1)", flexShrink: 0, fontSize: "14px" }} />
                  <a className="text-decoration-none text-white" href="tel:+21653278286" style={{ fontSize: "13px" }}>+216 53 27 82 86</a>
                </p>

                <p className="mb-2 d-flex align-items-center gap-2">
                  <FaPhone style={{ color: "#1fc17d", transform: "scaleX(-1)", flexShrink: 0, fontSize: "14px" }} />
                  <a className="text-decoration-none text-white" href="tel:+33753157294" style={{ fontSize: "13px" }}>+33 7 53 15 72 94</a>
                </p>

                <p className="mb-2 d-flex align-items-center gap-2">
                  <FaPhone style={{ color: "#1fc17d", transform: "scaleX(-1)", flexShrink: 0, fontSize: "14px" }} />
                  <a className="text-decoration-none text-white" href="tel:+966552526767" style={{ fontSize: "13px" }}>+966 55 25 26 767</a>
                </p>

                <p className="mb-2 d-flex align-items-center gap-2">
                  <FaEnvelope style={{ color: "#1fc17d", flexShrink: 0, fontSize: "14px" }} />
                  <a className="text-decoration-none text-white" href="mailto:cliclaim@cliclaim.com" style={{ fontSize: "13px" }}>cliclaim@cliclaim.com</a>
                </p>

                <div className="mb-1 d-flex align-items-start gap-2">
                  <FaMapMarkerAlt style={{ color: "#1fc17d", flexShrink: 0, fontSize: "14px", marginTop: "3px" }} />
                  <div>
                    <p className="mb-0 text-white" style={{ fontSize: "12px", fontWeight: "600" }}>{t("Tunis, Tunisie")}</p>
                    <a className="text-decoration-none text-white" href="https://maps.google.com/?q=15+CHEDLI+GTARI+EL+MENZEH+9,+Tunis,+1013" target="_blank" rel="noopener noreferrer" style={{ fontSize: "13px" }}>15 Chedli Gtari, El Menzah 9, Tunis 1013</a>
                  </div>
                </div>

                <div className="mb-0 d-flex align-items-start gap-2">
                  <FaMapMarkerAlt style={{ color: "#1fc17d", flexShrink: 0, fontSize: "14px", marginTop: "3px" }} />
                  <div>
                    <p className="mb-0 text-white" style={{ fontSize: "12px", fontWeight: "600" }}>{t("Riyad, Arabie Saoudite")}</p>
                    <a className="text-decoration-none text-white" href="https://maps.google.com/?q=Al+Miqdad,+Al+Rafiah,+Shumaisi,+Riyad+11373" target="_blank" rel="noopener noreferrer" style={{ fontSize: "13px" }}>Al Miqdad, Al Rafiah, Shumaisi, Riyad 11373</a>
                  </div>
                </div>
              </div>
            </div>

{/* ── Follow Us ── */}
<div className="col-12 col-md-4 col-lg-3 col-xl-2" style={{ marginBottom: '24px' }}>
  <div className="widget">
    <h4 className="widget-title text-white mb-3" style={{ fontSize: "16px", fontWeight: "bold", textAlign: "left" }}>
      {t("Follow us")}
    </h4>

    <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start" }}>

      <a href="https://www.facebook.com/profile.php?id=61588588681819" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "#cfcfcf", fontSize: "13px" }}>
        <img src={facebookIcon} alt="Facebook" style={{ width: "20px", height: "20px", objectFit: "contain" }} />
        <span>Facebook</span>
      </a>

      <a href="https://www.instagram.com/cli_claim/" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "#cfcfcf", fontSize: "13px" }}>
        <img src={instagramIcon} alt="Instagram" style={{ width: "20px", height: "20px", objectFit: "contain" }} />
        <span>Instagram</span>
      </a>

      <a href="https://www.tiktok.com/@cliclaim" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "#cfcfcf", fontSize: "13px" }}>
        <img src="https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/tiktok.svg" alt="TikTok" style={{ width: "20px", height: "20px", objectFit: "contain", filter: "invert(1)" }} />
        <span>TikTok</span>
      </a>

    </div>
  </div>
</div>

            {/* ── Learn More ── */}
<div className="col-12 col-md-4 col-lg-3 col-xl-2" style={{ marginBottom: '24px' }}>
              <div className="widget">
                <h4 className="widget-title text-white mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {t("Learn More")}
                </h4>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <Link to="/about" className="text-decoration-none text-white" style={{ fontSize: "13px" }}>{t("nav.about")}</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/terms" className="text-decoration-none text-white" style={{ fontSize: "13px" }}>{t("nav.terms")}</Link>
                  </li>
                  <li className="mb-0">
                    <Link to="/privacy" className="text-decoration-none text-white" style={{ fontSize: "13px" }}>{t("nav.privacy")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* ── Formulaire Contact ── */}
            <div className="col-12 col-lg-3 col-xl-4">
              <div className="widget">
                <h4 className="widget-title text-white mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {t("Contact")}
                </h4>
                <p className="mb-2 text-white" style={{ fontSize: "13px" }}>
                  {t("Leave your message.")}
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row gy-2">
                    <div className="col-12">
                      <input
                        type="email"
                        className="w-100 input_login"
                        placeholder={t("Email Address")}
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="w-100 input_login"
                        placeholder={t("Your Message")}
                        required
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        style={{
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "12px",
                          height: 60,
                          resize: "none",
                          paddingTop: "10px",
                          borderRadius: "8px",
                          display: "block",
                        }}
                      />
                    </div>
                    <div className="col-12 mt-2">
                      <button className="order_online3 w-100" type="submit" disabled={contactLoading}>
                        {contactLoading ? t("Sending...") : t("Send")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── Copyright ── */}
      <div
        className="container-fluid"
        style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)", marginTop: "20px" }}
      >
        <div className="d-flex justify-content-center align-items-center" style={{ padding: "14px 0" }}>
          <span style={{ fontSize: "13px", color: "rgba(255,255,255,0.5)" }}>
            <span style={{ color: "#18e68e" }}>C</span>li
            <span style={{ color: "#18e68e" }}>C</span>laim&nbsp;
            © {today?.getFullYear()}&nbsp;
            {t("All rights reserved.")}
          </span>
        </div>
      </div>

    </footer>
  );
}

export default Footer;